<template>
  <div class="molecule-select-node_container">
    <atom-checkbox
      class="select-node__select-all--checkbox"
      v-model="isCheckedAll"
      :isDisable="!listData.length"
      title="Select All"
      textStyle="font-weight:600;font-size:12px"
    ></atom-checkbox>
    <div v-if="listData.length" class="node-list_container">
      <div
        class="select-node__node-list"
        v-for="(node, index) in listData"
        :key="index"
      >
        <div
          class="select-node__node--bg"
          :class="{
            'select-node__node-list--selected':
              node.isSelected || node.nodeId === selectedNodeId,
          }"
          @click="selectNode(node)"
        ></div>
        <div
          v-if="node.isSelected || node.nodeId === selectedNodeId"
          :class="{
            'select-node__node-list--line':
              node.isSelected || node.nodeId === selectedNodeId,
          }"
        ></div>
        <div class="select-node__node-list--item">
          <atom-checkbox v-model="node.isChecked"></atom-checkbox>
          <span
            class="select-node__node--name"
            :class="{
              'select-node__text--primary': node.isChecked,
            }"
            @click="selectNode(node)"
            >{{ node.hostname }}</span
          >
        </div>
        <div :id="'tag-popover' + node.id" class="invalid-icon-position">
          <feather-icon
            v-if="node.backupStatus.toLowerCase() === 'failed'"
            icon="KeyIcon"
            size="16"
            stroke="#ea5455"
          />
        </div>
        <b-popover
          ref="popover"
          triggers="hover"
          placement="right"
          container="my-container"
          boundary="window"
          variant="danger"
          :target="'tag-popover' + node.id"
        >
          <template v-slot:title>
            <div class="d-flex justify-content-between align-items-left">
              <span class="text--normal-size">Invalid Credential</span>
            </div>
          </template>
          <div>
            <span class="text--small-size">Please Update SSH Credential.</span>
          </div>
        </b-popover>
      </div>
    </div>
    <div v-else class="no-node-message__container">
      <span>No matching node.</span>
    </div>
  </div>
</template>

<script>
import { BPopover } from "bootstrap-vue"
import AtomCheckbox from "@/components/atoms/AtomCheckbox.vue"
import mixinsValidator from "@/mixins/mixinsValidator"
export default {
  name: "MoleculeSelectNode",
  components: {
    AtomCheckbox,
    BPopover,
  },
  props: {
    listData: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  emits: ["checkedListData", "selectedData"],
  mixins: [mixinsValidator],
  data() {
    return {
      isCheckedAll: false,
      checkedList: null,
      selectedNode: null,
      isInitialCheck: true,
    }
  },
  computed: {
    selectedNodeId() {
      return this.$route?.params?.node_id
    },
  },
  watch: {
    isCheckedAll() {
      this.toggleCheck()
    },
    listData: {
      deep: true,
      handler() {
        this.addCheckedNodeList()
        this.initialSelectNode()
        /* INITIAL SELECT THE FIRST NODE START */
        if (this.isEmptyString(this.selectedNodeId) && this.listData.length) {
          this.$emit("selectedNode", this.listData[0])
        }
        /* INITIAL SELECT THE FIRST NODE END */
      },
    },
  },
  methods: {
    toggleCheck() {
      if (
        this.isCheckedAll &&
        this.checkedList.length !== this.listData.length
      ) {
        for (var i = 0; i < this.listData.length; i++) {
          this.listData[i].isChecked = true
        }
      }
      if (
        !this.isCheckedAll &&
        this.checkedList.length === this.listData.length
      ) {
        for (var i = 0; i < this.listData.length; i++) {
          this.listData[i].isChecked = false
        }
      }
    },
    addCheckedNodeList() {
      this.checkedList = []
      for (var i = 0; i < this.listData.length; i++) {
        if (this.listData[i].isChecked) {
          this.checkedList.push(this.listData[i])
        }
        if (this.checkedList.length === this.listData.length) {
          this.isCheckedAll = true
        } else {
          this.isCheckedAll = false
        }
      }
      this.$emit("checkedListData", this.checkedList)
    },
    selectNode(node) {
      if (this.selectedNode?.nodeId !== node.nodeId) {
        this.selectedNode = node
        this.$emit("selectedNode", this.selectedNode)
      }
    },
    initialSelectNode() {
      if (this.listData.length !== 0 && this.isInitialCheck) {
        this.isInitialCheck = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.select-node__select-all--checkbox {
  margin-bottom: 5px;
  margin-left: 15px;
  margin-right: 15px;
}

.select-node__node-list {
  display: flex;
  position: relative;
  align-items: center;
  height: 36px;
  padding-left: 15px;
  padding-right: 15px;
  &:hover {
    cursor: pointer;
  }
}

.select-node__node-list--item {
  display: flex;
  align-items: center;
  position: absolute;
  &:hover {
    cursor: pointer;
  }
}

.select-node__node-list--selected {
  background-color: #eeedfd;
}

.select-node__node-list--line {
  position: absolute;
  left: 0;
  content: none;
  height: 100%;
  border-left: 4px solid #7367f0;
  border-radius: 5px;
}

.select-node__text--primary {
  color: #7367f0;
  font-weight: 500;
}

.select-node__node--bg {
  content: none;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 0;
}

.node-list_container {
  height: 250px;
  overflow-y: auto;
}

.no-node-message__container {
  text-align: center;
}

.invalid-icon-position {
  position: absolute;
  right: 10px;
}

.text--normal-size {
  font-size: 14px;
}

.text--small-size {
  font-size: 12px;
}

.select-node__node--name {
  width: 100%;
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
  .node-list_container {
    height: 325px;
    overflow-y: auto;
  }
}

@media screen and (min-width: 992px) {
  .node-list_container {
    height: calc(100vh - 28rem);
    overflow-y: auto;
  }
  .select-node__node-list--item {
    width: 190px;
  }
  .select-node__node--name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
